import React from 'react';


function Title() {
  return (
    <div className="Title">
        <header>
            <h2>Little Free Library Demographic Explorer</h2>
        </header>
    </div>
  )
}

export default Title